<div class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="text-center px-4 py-8">
    <div class="error-message">
      <h1 class="text-9xl text-gray-200 mb-2 flex items-center justify-center">
        4<i class="svg404"></i>4
      </h1>
      <h2 class="text-lg leading-relaxed text-teal-500 mb-5">
        Congratulations!
        <span class="block text-black text-sm font-light">
          You are one of the elite few who has managed to find our 404 page.
        </span>
      </h2>
      @if (!errorMessage) {
        <p class="text-sm leading-relaxed">
          <b>Don't worry - </b>this is not a dead end. Looks like you tried to
          open a page which is not available.<br />
          Please enter correct page url and try again.
        </p>
      }
      @if (errorMessage) {
        <p class="text-sm leading-relaxed">
          <b>{{ errorMessage }}</b>
        </p>
      }
    </div>
  </div>
</div>
